export default {
  aLogin({
    commit
  }, payload) {
    commit('login', payload);
  }
}